'use client';

import { c as _c } from "react/compiler-runtime";
import avatarIcon from '@public/images/avatar.svg';
import Image from 'next/image';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { useSession } from '@src/hooks/useSession';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
export const TopNavV5MobileBar = () => {
  const $ = _c(22);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    t
  } = useLocale("common");
  const {
    user
  } = useSession();
  const {
    logo,
    setAccountExpanded,
    mobileDispatch
  } = useTopNavV5();
  let t0;
  if ($[0] !== mobileDispatch) {
    t0 = () => <button data-testid="topNavMobileMenu" onClick={() => {
      mobileDispatch({
        type: "OPEN"
      });
    }} className={"flex size-6 appearance-none flex-col items-center justify-center\n          *:h-0.5 *:w-6 *:rounded-sm *:bg-white *:transition-all"}><div className="-translate-y-1" /><div /><div className="translate-y-1" /></button>;
    $[0] = mobileDispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const renderHamburger = t0;
  let t1;
  if ($[2] !== renderHamburger) {
    t1 = <div className="flex items-center">{renderHamburger()}</div>;
    $[2] = renderHamburger;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== logo || $[5] !== trackSelectNavCta) {
    t2 = logo?.src && <LocalizedLink onClick={() => {
      trackSelectNavCta({
        "cta url": logo?.href
      });
    }} href={logo?.href ?? ""}><Image src={logo.src} width={logo?.mobileWidth} height={logo?.mobileHeight} alt={logo?.altText ?? ""} /></LocalizedLink>;
    $[4] = logo;
    $[5] = trackSelectNavCta;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="flex gap-6">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== setAccountExpanded) {
    t4 = () => {
      setAccountExpanded(true);
    };
    $[10] = setAccountExpanded;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src={avatarIcon} width={24} height={24} alt="Account icon" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t || $[14] !== user) {
    t6 = user ? t("my-account") : t("login-join");
    $[13] = t;
    $[14] = user;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <div className="flex gap-3"><button onClick={t4} data-testid="bodiBtn" className="flex items-center gap-2 font-medium text-bodi-gray-butters">{t5}{t6}</button></div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t7) {
    t8 = <Container className="h-full *:h-full"><div className="flex h-full flex-row items-center justify-between">{t3}{t7}</div></Container>;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};